import { intervalToDuration, Duration } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { styles } from './Countdown.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export type CountdownProps = {
  endDate: Date;
  startDate?: Date;
};

type TimeElementProps = {
  value: number;
  label: string;
};

const TimeElement = ({ value, label }: TimeElementProps) => (
  <div className={styles.element}>
    <CalloutFont>{value}</CalloutFont>
    <CalloutFont className={styles.elementLabel}>{label}</CalloutFont>
  </div>
);

const TIME_ELEMENTS: Array<{ key: keyof Duration; label: string }> = [
  { key: 'days', label: 'days' },
  { key: 'hours', label: 'hrs' },
  { key: 'minutes', label: 'min' },
  { key: 'seconds', label: 'sec' },
];

const ZERO_DURATION: Duration = {
  days: 0,
  hours: 0,
  months: 0,
  minutes: 0,
  weeks: 0,
  years: 0,
  seconds: 0,
};

export const Countdown = ({ endDate, startDate }: CountdownProps) => {
  const [distance, setDistance] = useState<Duration>({});

  const updateTime = () => {
    const _startDate = startDate ? startDate : new Date();
    if (_startDate <= endDate) {
      const computedDuration = intervalToDuration({ start: _startDate, end: endDate });
      setDistance({ ...ZERO_DURATION, ...computedDuration });
    } else {
      setDistance(ZERO_DURATION);
    }
  };

  useEffect(() => {
    updateTime(); // update time once immediately, then start the interval update
    const interval = setInterval(() => {
      updateTime();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!distance) return null;
  return (
    <div className={styles.container}>
      {TIME_ELEMENTS.map(element => (
        <TimeElement key={element.key} value={distance[element.key] as number} label={element.label} />
      ))}
    </div>
  );
};
